export var AlertType;
(function (AlertType) {
    AlertType[AlertType["MaintenanceRequired"] = 1] = "MaintenanceRequired";
    AlertType[AlertType["MaintenanceNotCarriedOut"] = 2] = "MaintenanceNotCarriedOut";
    AlertType[AlertType["MaintenanceCompleted"] = 3] = "MaintenanceCompleted";
    AlertType[AlertType["TooManyPlayers"] = 4] = "TooManyPlayers";
    AlertType[AlertType["MovementOutOfHours"] = 5] = "MovementOutOfHours";
    AlertType[AlertType["CalendarEventAssigned"] = 6] = "CalendarEventAssigned";
    AlertType[AlertType["CalendarRecurrenceEventAssigned"] = 7] = "CalendarRecurrenceEventAssigned";
})(AlertType || (AlertType = {}));
//# sourceMappingURL=alertType.enum.js.map